export default __webpack_public_path__ + "static/media/rocket_anim_24.a58ebd2a.png";